module.exports = {
  ACH: 'ach',
  BLOCKCHAIN: 'blockchain',
  CARD: 'card',
  WIRE: 'wire',
};
